module.exports = __webpack_public_path__ + "static/media/beyaz1.e84ea864.png";